import { render, staticRenderFns } from "./CommonLinks.vue?vue&type=template&id=8552d6ba&scoped=true"
import script from "./CommonLinks.vue?vue&type=script&lang=js"
export * from "./CommonLinks.vue?vue&type=script&lang=js"
import style0 from "./CommonLinks.vue?vue&type=style&index=0&id=8552d6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8552d6ba",
  null
  
)

export default component.exports